<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container reports-container">
    <!-- Page Header -->
    <div class="page-title-section">
      <h1><mat-icon>assessment</mat-icon> Relatórios</h1>
      <p class="page-subtitle">Selecione um relatório para fazer o download</p>
    </div>

    <!-- Reports Grid -->
    <div class="reports-grid">
      <!-- Vendas e Comissão -->
      <mat-card class="report-card" (click)="downloadReport('COMMISSION')">
        <div class="card-icon-wrapper success">
          <mat-icon>attach_money</mat-icon>
        </div>
        <div class="card-content">
          <h3>Vendas e Comissão</h3>
          <p>Relatório completo de vendas realizadas e comissões geradas</p>
        </div>
        <div class="card-action">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </div>
      </mat-card>

      <!-- CAIs Não Atendidos -->
      <mat-card class="report-card" (click)="downloadReport('ORDERS_NOT_SERVED')">
        <div class="card-icon-wrapper warning">
          <mat-icon>pending_actions</mat-icon>
        </div>
        <div class="card-content">
          <h3>CAIs Não Atendidos</h3>
          <p>Lista de pedidos pendentes que ainda não foram processados</p>
        </div>
        <div class="card-action">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </div>
      </mat-card>

      <!-- Pedidos Cancelados -->
      <mat-card class="report-card" (click)="downloadReport('ORDERS_CANCELED')">
        <div class="card-icon-wrapper danger">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <h3>Pedidos Cancelados</h3>
          <p>Histórico de todos os pedidos que foram cancelados</p>
        </div>
        <div class="card-action">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </div>
      </mat-card>

      <!-- Relatório Unificado -->
      <mat-card class="report-card" (click)="downloadReport('ORDERS_FULL')">
        <div class="card-icon-wrapper primary">
          <mat-icon>summarize</mat-icon>
        </div>
        <div class="card-content">
          <h3>Relatório Unificado</h3>
          <p>Visão consolidada de todos os pedidos e transações</p>
        </div>
        <div class="card-action">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </div>
      </mat-card>
    </div>

    <app-automaker-select-modal (selectedAutomakerId)="onAutomakerSelected($event)"></app-automaker-select-modal>
  </div>
</mic-spinner-overlay>